module.exports = __webpack_public_path__ + "img/awb-not-found.e7867066.svg";